import React from 'react';
import Modal from '../modal/modal';
import styles from './fnfSettlementModal.scss';

const FnfSettlementModal = ({
  showModal,
  closeModal = () => {},
  handleSubmitClick = () => {},
  fnfAmount
}) => {
  const modalBodyContent = () => {
    return (
      <>
        An amount of{' '}
        <span className={styles.amountInfoSpanInModal}>
          Rs. {fnfAmount || 0}
        </span>{' '}
        is still not used from the wallet.
        <p>Would you like to confirm this settlement?</p>
      </>
    );
  };
  return (
    <Modal
      title={'FnF SETTLEMENT'}
      showModal={showModal}
      closeModal={() => closeModal()}
      showCloseOption={false}
      classNameProp="fnfModal"
    >
      <div className={styles.fnfSettlementModalWrapper}>
        <div className={styles.fnfSettlementModalBody}>
          {modalBodyContent()}
        </div>
        <div className={`${styles.fnfFooterSection} l-row a-center `}>
          <div className="flex-100 l-row j-end a-center">
            <div
              className={` ${styles.cancelBtnWrapper} cancel-btn-wrapper l-row j-center a-center`}
              onClick={() => closeModal(false)}
            >
              CANCEL
            </div>
            <div
              className={` ${styles.submitBtnWrapper} submit-btn-wrapper l-row j-center a-center `}
              onClick={handleSubmitClick}
            >
              CONFIRM
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FnfSettlementModal;
